// extracted by mini-css-extract-plugin
export var infoSection = "_w-1";
export var infoSectionContainer = "_w-0";
export var infoSectionTitleRow = "_w-2";
export var multiLineInfo = "_w-4";
export var strong = "_w-3";